import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 获取身份列表
export const getpersonList = params => {
    return get("/admin/staff", params);
};
// 新增身份
export const addPerson = params => {
    return post("/admin/staff", params);
};
// 修改身份
export const editPerson = params => {
    const dataId = params.id
    delete params.id
    return put(`/admin/staff/${dataId}`, params);
};
// 删除身份
export const deletePerson = params => {
    return del(`/admin/staff/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/identity.js